import { render, staticRenderFns } from "./CreateArea.vue?vue&type=template&id=3c3d60e2"
import script from "./CreateArea.vue?vue&type=script&lang=js"
export * from "./CreateArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports